export enum MARITAL_STATUSES {
  CIVIL_UNION = 'civil_union',
  DIVORCED = 'divorced',
  DOMESTIC_PARTNERSHIP = 'domestic_partnership',
  MARRIED = 'married',
  NEVER_MARRIED = 'never_married',
  NOT_MARRIED = 'not_married',
  SEPARATED = 'separated',
  SINGLE = 'single',
  WIDOWED = 'widowed'
}
